import { useLocation, useNavigate } from "react-router-dom";
export default function Footer() {
  const navigate=useNavigate();
  const location=useLocation();

  const scrollToSection=(id) => {
    if (location.pathname==="/") {
      const el=document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.hash=id;
      }
      return;
    }
    navigate(`/#${id}`);
    setTimeout(() => {
      const el=document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 250);
  };
  return (
    <footer
      id="contact"
      className="bg-[#2B1B5C] text-white py-12 md:py-16 px-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 mb-12 md:mb-16">
          <div>
            <h3 className="font-bold text-white mb-4 md:mb-6 text-sm tracking-wide">
              NAVIGATION
            </h3>
            <ul className="space-y-2 md:space-y-3 text-white/70 text-sm">
              <li>
                <button
                  type="button"
                  aria-label="Home"
                  onClick={() => navigate("/")}
                  className="hover:text-white transition-colors bg-transparent p-0"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  type="button"
                  aria-label="About Us"
                  onClick={() => scrollToSection("about")}
                  className="hover:text-white transition-colors bg-transparent p-0"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  type="button"
                  aria-label="What We Do"
                  onClick={() => scrollToSection("features")}
                  className="hover:text-white transition-colors bg-transparent p-0"
                >
                  Features{" "}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-white mb-4 md:mb-6 text-sm tracking-wide">
              LEGAL
            </h3>
            <ul className="space-y-2 md:space-y-3 text-white/70 text-sm">
              <li>
                <button
                  type="button"
                  aria-label="Privacy Policy"
                  className="hover:text-white transition-colors bg-transparent p-0"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  type="button"
                  aria-label="Terms of Service"
                  className="hover:text-white transition-colors bg-transparent p-0"
                >
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="font-bold text-white mb-4 md:mb-6 text-sm tracking-wide">
              TALK TO US
            </h3>
            <ul className="space-y-2 md:space-y-3 text-white/70 text-sm">
              <li>
                <a
                  href="mailto:support@astrauniv.com"
                  className="hover:text-white transition-colors"
                >
                  support@astrauniv.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+917869941174"
                  className="hover:text-white transition-colors"
                >
                  +91 7869941174
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
          <p className="text-white/70 text-xs md:text-sm text-center md:text-left">
            © 2025. ASTRAMINER . All right reserved.
          </p>

          {/* <div className="flex gap-3 md:gap-4">
            <button
              type="button"
              aria-label="Facebook"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors bg-transparent p-0"
            >
              <svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </button>
            <button
              type="button"
              aria-label="LinkedIn"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors bg-transparent p-0"
            >
              <svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </button>
            <button
              type="button"
              aria-label="Twitter"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors bg-transparent p-0"
            >
              <svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
              </svg>
            </button>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
